// extracted by mini-css-extract-plugin
export var dividerContainer = "_9p-0";
export var line = "_9p-1";